module.exports = __webpack_public_path__ + "img/3 inty-gronneberg-circulo.4b8ea05f.png";